import ReactDOM from "react-dom"
import React from "react"

import { useA11yDialog } from "react-a11y-dialog"
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock"
import type { BodyScrollOptions } from "body-scroll-lock"

export interface ModalWrapperProps {
  id: string
  title: unknown
  buttonText: string
}

const ModalWrapper: React.FC<ModalWrapperProps> = props => {
  let targetElement = null

  const [instance, attr] = useA11yDialog({
    id: props.id,
    role: "dialog",
    title: props.id + "-title",
  })

  const options: BodyScrollOptions = {
    reserveScrollBarGap: true,
  }

  const onShow = () => {
    targetElement = document.getElementById(props.id)
    disableBodyScroll(targetElement, options)
    instance.show()
  }

  const onHide = () => {
    targetElement = document.getElementById(props.id)
    enableBodyScroll(targetElement)
    instance.hide()
  }

  const dialog =
    typeof document !== "undefined"
      ? ReactDOM.createPortal(
          <div
            aria-live="assertive"
            {...attr.container}
            className="o-modal__container"
          >
            <div
              {...attr.overlay}
              className="o-modal__overlay c-modal__overlay"
            />
            <div {...attr.dialog} className="o-modal__content c-modal__content">
              <h2 {...attr.title} className="u-visually-hidden">
                {props.buttonText}
              </h2>
              {props.children}
              <button
                {...attr.closeButton}
                className="c-modal__close"
                onClick={onHide}
              >
                <span className="u-visually-hidden">Stäng modal</span>
              </button>
            </div>
          </div>,
          document.body
        )
      : null

  return (
    <>
      <button className="c-cta -green" type="button" onClick={onShow}>
        {props.buttonText}
      </button>
      {dialog}
    </>
  )
}

export default ModalWrapper
